import { Component, Input } from '@angular/core';
import { EntityTypeDefaultImageEnum } from '../../../../../../Common/Misc/enums/entity-type-default-image.enum';
import { EmailRecipientModel } from '../../../../../../Common/TargetingShared/model/statisticsReport/email-recipient.model';
import { topStatLabels } from '../../../../../../Common/TargetingShared/model/statisticsReport/distribution-report-stat-map.model';
import { ActionKeys } from '../../../../../../Common/Forms/enums/keys.enum';
import { EmailEventInterface } from '../../../../../../Common/TargetingShared/model/statisticsReport/email-event.interface';
import { CurrentUserStateService } from '../../../../../../Core/Users/services/current-user-state.service';
import { Subscription, filter } from 'rxjs';
import moment from 'moment-timezone';
import { ButtonTypesEnum } from '../../../../../../Common/Forms/enums/button-types.enum';


@Component({
    selector: 'agpr-email-recipient-card',
    templateUrl: './email-recipient-card.component.html',
    styleUrls: ['./email-recipient-card.component.scss'],
    standalone: false
})
export class EmailRecipientCardComponent {
    readonly imageDefault = EntityTypeDefaultImageEnum;
    readonly topStatLabels = topStatLabels;
    readonly buttonTypes = ButtonTypesEnum;

    @Input() set recipient(recipient: EmailRecipientModel) {
        if (recipient) {
            this.email = recipient.email;
            this.name = recipient.email.substring(0, recipient.email.indexOf('@'));
            this.status = topStatLabels.get(recipient.status);

            if (!this.status) {
                this.status = 'Discover.distributionReport.recipient.statsType.pending';
            }

            this.linkEvents = [];
            this.otherEvents = [];
            recipient.events?.forEach(item => {
                if (item.clickedUrl) {
                    this.linkEvents.push(item);
                } else {
                    this.otherEvents.push(item);
                }
            });

            this.convertEventToUserTimezone();
        }
    }

    name: string;
    email: string;
    status: string;
    expanded: boolean;
    linkEvents: EmailEventInterface[];
    otherEvents: EmailEventInterface[];
    timezone: string;
    private subscriptions: Subscription[] = [];


    constructor(
        private currentUserStateService: CurrentUserStateService,
    ) {
        this.subscriptions.push(
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(
                preferences => {
                    this.timezone = preferences?.timeZone;
                }
            )
        );
    }

    toggle(keydown?: KeyboardEvent): void {
        if (!keydown || keydown.key === ActionKeys.ENTER) {
            this.expanded = !this.expanded;
        }
    }

    convertEventToUserTimezone(): void {
        if ( this.linkEvents?.length || this.otherEvents?.length) {
            if (this.timezone) {
                this.linkEvents?.forEach(event => event.date =
                    +event.date > 0 ? moment(event.date).tz(this.timezone).format('MMM DD, y - h:mm a') : event.date);
                this.otherEvents?.forEach(event => event.date =
                    +event.date > 0 ? moment(event.date).tz(this.timezone).format('MMM DD, y - h:mm a') : event.date);
            } else {
                this.linkEvents?.forEach(event => event.date =
                    +event.date > 0 ?moment(event.date).format('MMM DD, y - h:mm a') : event.date);
                this.otherEvents?.forEach(event => event.date =
                    +event.date > 0 ? moment(event.date).format('MMM DD, y - h:mm a') : event.date);
            }
        }
    }
}
